module.exports = __webpack_public_path__ + "static/media/withdraw_blue.1036d525.svg";